import DialogReader from "./DialogReader"
import EditDialog from "./EditDialog.vue"
import store from "@/store/index"
import { shallowRef } from "vue";
class DialogItem{
	constructor(component,props,events){
		// this.component=component;
		this.component=shallowRef(component);
		this.props=props;
		this.events=events;
	}
	isTop(){
    var dialogs = store.getters.getEditDialogs;
		return dialogs[dialogs.length-1]==this;
	}
}

const dialog = {
    install(Vue){
      Vue.component("DialogReader",DialogReader)
      Vue.component("EditDialog",EditDialog)
    },
    isEmpty(){
        var dialogs = store.getters.getEditDialogs;
        return dialogs.length==0;
    },
    open:function(component,props,listeners){
        var dialogs = store.getters.getEditDialogs;
        dialogs.push(new DialogItem(component,props,listeners))
    },
    close(){//关闭最上面
      //let index=store.items.findIndex(c=>item==c)
      //store.items.splice(index,1);
      var dialogs = store.getters.getEditDialogs;
      dialogs.pop();
      store.commit('setEditDialogs', dialogs)
    },
    getItems(){
        return store.getters.getEditDialogs;
    },
    clear:function() {
      store.commit('setEditDialogs', [])
    },
}
export default dialog;
